import { GA4 } from '../../../utils/trackers/GA4'
import { EVENT_ERROR } from './constants'

export const getMediaDataMetrics = (mediaData, isSerie) => {
  const episode = mediaData && mediaData.extendedcommon && mediaData.extendedcommon.media && mediaData.extendedcommon.media.episode;
  const provider = mediaData && mediaData.extendedcommon && mediaData.extendedcommon.media && mediaData.extendedcommon.media.proveedor;
  const genre = mediaData && mediaData.extendedcommon && mediaData.extendedcommon.genres && mediaData.extendedcommon.genres.genre;
  const format = mediaData && mediaData.extendedcommon && mediaData.extendedcommon.format;

  return {
    content_id: mediaData && mediaData.id ? mediaData.id : null,
    content_name: mediaData && mediaData.title ? mediaData.title : null,
    content_type: isSerie ? 'serie' : 'movie',
    content_category: genre && genre[0] && genre[0].name ? genre[0].name : null,
    content_availability: format && format.sell_type ? format.sell_type : null,
    content_episode: episode && episode.number ? episode.number : null,
    content_season: episode && episode.season ? episode.season : null,
    provider: provider && provider.nombre ? provider.nombre : null,
  };
}

export const sendMetricsRating = (type = '', data = {}) => {
  const history = window.history
  const interaction_type = null
  const pagePath = null
  const contentSection = window.location.pathname.split('/').filter(Boolean).pop() || null;
  const contentSubsection = null

  let dataMetrics = {
    history,
    page_path: pagePath,
    page_title: contentSection,
    page_url: window.location.href,
    content_section: contentSection,
    content_subsection: contentSubsection,
    interaction_type: data.interaction_type != null ? data.interaction_type : null,
    rating_message: data.rating_message != null ? data.rating_message : null,
    content_id: data.content_id != null ? data.content_id : null,
    content_name: data.content_name != null ? data.content_name : null,
    content_type: data.content_type != null ? data.content_type : null,
    content_category: data.content_category != null ? data.content_category : null,
    content_availability: data.content_availability != null ? data.content_availability : null,
    modulo_name: data.modulo_name != null ? data.modulo_name : null,
    content_episode: data.content_episode != null ? data.content_episode : null,
    content_season: data.content_season != null ? data.content_season : null,
    provider: data.provider != null ? data.provider : null,
  }

  if(type === EVENT_ERROR){
    const dataError = {
        error_title: data.error_title != null ? data.error_title : null,
        error_message: data.error_message != null ? data.error_message : null,
        error_type: data.error_type != null ? data.error_type : null,
        error_code: data.error_code != null ? data.error_code : null,
    } 
    
    dataMetrics = {
      ...dataMetrics,
      ...dataError
    }
  }

  const gA4 = new GA4()
  gA4.sendMetricsRating(type, dataMetrics)
}


// WEBPACK FOOTER //
// ./src/components/Modal/ratingContent/utils.js